module.exports = __webpack_public_path__ + "static/media/model-mission-15.678aad08.png";